<template>
  <div class="home-page">
    <div class="news clearfix">
      <div class="top_div mar-center">
        <div class="w_630">
          <div class="ind01_pic">
            <div class="main" id="ind01_main">
              <div class="btn_l" id="btn_l" style="display: block" @click="cacluateIndex('minus')"></div>
              <div class="btn_r" id="btn_r" style="display: block" @click="cacluateIndex('plus')"></div>
              <div class="content" style="width: 550px; height: 390px; overflow: hidden">
                <div class="shadow">
                  <ul id="list26">
                    <li :class="{ atur: currImgIndex === index }" v-for="(item, index) in textList" :key="index">
                      <p>
                        <a :href="`/article-detail/${item.url}`" target="_blank">{{ item.text.slice(0, 32) }}</a>
                      </p>
                    </li>
                  </ul>
                </div>
                <ul class="img" id="listDiv26">
                  <li :class="{ cur: currImgIndex === index }" v-for="(item, index) in imgList" :key="index">
                    <div class="shadow-inner" style="width: 100%; height: 100%"></div>
                    <a :href="`/article-detail/${item.url}`" target="_blank">
                      <el-image style="width: 600px; height: 430px;" :src="item.src" fit="cover" />
                    </a>
                  </li>
                </ul>
                <div id="change_I" class="change" style="display: block">
                  <span id="listSpan26"><i :class="{ cur: currImgIndex === index }"
                      v-for="(item, index) in imgList"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="top_r" id="list16">
          <div class="hd_text">
            <h3>
              <a href="/detail?t=5&d=16&l=0" target="_blank">通知公告</a>
            </h3>
            <h4 v-for="(item, index) in noticeList" :key="item.threadId">
              <a :href="`/article-detail/${item.threadId}`" :title="item.title" target="_blank" class="tz">
                {{ item.title }}</a><em>{{ item.createTime }}</em>
            </h4>

            <p class="top_gd" id="list3">
              <a href="/detail?t=5&d=16&l=0" target="_blank"><em>---</em>&nbsp;&nbsp;查看更多通告&nbsp;&nbsp;<em>---</em></a>
            </p>
          </div>
        </div>
      </div>
      <!--------规范服务，提供诉求------->
      <div class="mar-center" style="font-size: 0; margin-bottom: 10px; padding-top: 20px">
        <img style="width: 100%" src="~@/assets/images/b_hf.jpg" usemap="#exampleMap" alt="" />
        <map name="exampleMap">
          <area shape="rect" target="_blank" coords="122,50,314,149" href="http://z.tjchxh.org.cn/login?type=member"
            alt="会员服务中心" />
          <area shape="rect" target="_blank" coords="406,42,596,151" href="http://z.tjchxh.org.cn/login" alt="会议活动中心" />
          <area shape="rect" target="_blank" coords="662,42,912,151" href="http://z.tjchxh.org.cn/login"
            alt="优秀技术成果评定" />
          <area shape="rect" target="_blank" coords="976,42,1165,151" href="http://z.tjchxh.org.cn/login?type=monitor"
            alt="产业监测中心" />
        </map>
      </div>

      <!------产业动态-----协会要闻-----会员新闻----->
      <div class="news-center">
        <div style="
          margin: 0 auto;
          width: 1230px;
          overflow: hidden;
          padding-left: 17px;
        ">
          <dl class="bg01">
            <dt>产业动态</dt>
            <dd>
              <ul>
                <li v-for="item in newsList['cydt']">

                  <a :href="`/article-detail/${item.threadId}`" target="_blank" class="title-text">{{ item.title }}</a>
                  <span>{{ item.createTime }}</span>
                </li>
              </ul>
              <div class="view-more">
                <a :href="`/detail?t=5&d=20&l=0`" target="_blank">查看更多 -></a>
              </div>
            </dd>
          </dl>
          <dl class="mid">
            <dt>协会要闻</dt>
            <dd>
              <ul>
                <li v-for="item in newsList['xhyw']">
                  <a :href="`/article-detail/${item.threadId}`" target="_blank" class="title-text">{{ item.title }}</a>
                  <span>{{ item.createTime }}</span>
                </li>
              </ul>
              <div class="view-more">
                <a :href="`/detail?t=5&d=26&l=0`" target="_blank">查看更多 -></a>
              </div>
            </dd>
          </dl>
          <dl class="bg03">
            <dt>会员新闻</dt>
            <dd>
              <ul>
                <li v-for="item in newsList['hyxw']">
                  <a :href="`/article-detail/${item.threadId}`" target="_blank" class="title-text">{{ item.title }}</a>
                  <span>{{ item.createTime }}</span>
                </li>
              </ul>
              <div class="view-more">
                <a :href="`/detail?t=5&d=22&l=0`" target="_blank">查看更多 -></a>
              </div>
            </dd>
          </dl>
        </div>

        <div class="member-intro">
          <h1 class=""><img src="~@/assets/images/member_intro.png" /></h1>
          <div class="news">
            <ul>
              <li v-for="(item, index) in members1">
                <a :href="`/article-detail/${item.threadId}`" :title="item.title" target="_blank" class="la">
                  {{ item.title }}</a>
              </li>
            </ul>
            <ul>
              <li v-for="(item, index) in members2">
                <a :href="`/article-detail/${item.threadId}`" :title="item.title" target="_blank" class="la">
                  {{ item.title }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="down-center">
        <div class="down-center-wraper">
          <div class="down-center-title">下载中心</div>
          <div class="container">
            <ul class="download-list">
              <li class="list-item" v-for="item in downloadList">
                <a :href="`/article-detail/${item.threadId}`" :title="item.title" target="_blank" class="item-text">{{
                  item.title }}</a>
                <button class="download-btn">下载 ▼</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup>
import { getBanners, getHomeList, getListContent } from "@/api/home";
import { ref } from "vue";
let currImgIndex = ref(0);
let textList = ref([]);
let imgList = ref([]);
let timerId = null;
let noticeList = ref([]);
// 启动banner轮播
getHomeBanners();
function getHomeBanners() {
  getBanners({
    f: "5d8354b4d0163f26",
    t: "c81d7da7b8ab3ddb",
  }).then((res) => {
    if (res.code === 200) {
      imgList.value = res.data.map((item) => {
        return {
          src: item.src,
          url: item.url,
        };
      });
      textList.value = res.data.map((item) => {
        return {
          text: item.text,
          url: item.url,
        };
      });
      startBanners();
    }
  });
}
// 获取通知列表
getNotices();
function getNotices() {
  getHomeList({
    f: "61C4B5DE8E528E4E",
    t: "92AB46C24F70248C",
  }).then((res) => {
    if (res.code === 200) {
      noticeList.value = res.data.threadVOS;
    }
  });
}

let members1 = ref([]);
let members2 = ref([]);
getMembers();
// 获取会员简介
function getMembers() {
  getHomeList({
    f: "C2C781D3A4501829",
    t: "92AB46C24F70248C",
  }).then((res) => {
    if (res.code === 200) {
      members1.value = res.data.threadVOS.slice(0, 5);
      members2.value = res.data.threadVOS.slice(5, 10);
    }
  });
}
let downloadList = ref([]);
getDownloadList();
// 获取下载中心
function getDownloadList() {
  getHomeList({
    f: "01B0458295111A31",
    t: "92AB46C24F70248C",
  }).then((res) => {
    if (res.code === 200) {
      downloadList.value = res.data.threadVOS;
    }
  });
}

function cacluateIndex(type) {
  if (type === "plus") {
    if (currImgIndex.value >= imgList.value.length - 1) {
      currImgIndex.value = 0;
    } else {
      currImgIndex.value++;
    }
  } else {
    if (currImgIndex.value <= 0) {
      currImgIndex.value = imgList.value.length - 1;
    } else {
      currImgIndex.value--;
    }
  }
}

function startBanners() {
  if (timerId) {
    clearInterval(timerId);
  }
  if (imgList.value.length > 0 && textList.value.length > 0) {
    timerId = setInterval(() => {
      cacluateIndex("plus");
    }, 3000);
  }
}
let newsList = ref({
  cydt: [],
  xhyw: [],
  hyxw: [],
});

// 获取产业动态
getList(
  {
    f: "A2CDD2B2A27BC205",
    t: "92269198826BABD8",
  },
  "cydt"
);
// 获取协会要闻
getList(
  {
    f: "5D8354B4D0163F26",
    t: "92269198826BABD8",
  },
  "xhyw"
);
// 获取会员新闻
getList(
  {
    f: "80BF13DB70EA3901",
    t: "92269198826BABD8",
  },
  "hyxw"
);

// 获取产业动态， 协会要闻和会员新闻
function getList(params, type) {
  getHomeList({ ...params }).then((res) => {
    if (res.code === 200) {
      newsList.value[type] = res.data.threadVOS;
    } else {
      console.log(res.message);
    }
  });
}
</script>
<style lang="scss">
.home-page {
  background: url("~@/assets/images/bg_mountain.jpg") center 0px no-repeat fixed;
  padding-top: 10px;
}

.down-center {
  width: 100%;
  height: 503px;
  // background-color: #eff0f4;
  // background-image: url("~@/assets/images/down_center.jpg");
  /* 背景图设置 */
  background-repeat: no-repeat;
  /* 不重复 */
  background-position: center -15px;

  /* 居中显示 */
  .down-center-wraper {
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
  }

  .down-center-title {
    width: 223px;
    height: 60px;
    border-radius: 8px;
    background-color: #ced4df;
    color: #1586dc;
    font-size: 38px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 2px;
  }

  .container {
    width: 100%;
    margin: 0 auto;

    .download-list {
      padding: 30px 0 0 0;
      margin: 0;
      width: 100%;

      .list-item {
        float: left;
        padding: 0;
        margin: 0;
        width: 47%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        background-color: #cdd4de;
        margin-bottom: 6px;
        border-radius: 4px;
        margin-right: 2%;

        &:nth-child(even) {
          margin-right: 0;
        }

        .item-text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #000;
          font-size: 15px;
          font-weight: 500;
        }

        .download-btn {
          background-color: #fff;
          border: 1px solid #b3d9ff;
          border-radius: 4px;
          padding: 5px 10px;
          cursor: pointer;
          color: #0066cc;
          transition: background-color 0.3s ease;

          &:hover {
            background-color: #b3d9ff;
          }
        }
      }
    }
  }
}

.news-center {
  width: 100%;
  overflow: hidden;
  height: 640px;
  // background: url("~@/assets/images/bg_mountain.jpg") center -130px no-repeat;
  margin-top: 10px;

  dl {
    float: left;
    padding-left: 6px;

    padding-top: 20px;

    dt {
      box-sizing: border-box;
      width: 375px;
      height: 50px;
      font-size: 26px;
      line-height: 50px;
      padding: 0 0 20px 20px;
      margin-bottom: 10px;
      letter-spacing: 1px;
      text-shadow: 1px 0px 2px #eee;
      color: #43474a;
      font-family: '黑体';
    }

    &.bg01 {
      width: 392px;
      height: 396px;
      background: url("~@/assets/images/bg_cydt.png") no-repeat;
    }

    &.mid {
      margin: 0 18px;
      width: 392px;
      height: 396px;
      background: url("~@/assets/images/bg_xhyw.png") no-repeat;
    }

    &.bg03 {
      width: 392px;
      height: 396px;
      background: url("~@/assets/images/bg_hyxw.png") no-repeat;
    }

    .title {
      width: 330px;
      height: 100px;
    }



    dd {
      box-sizing: border-box;
      width: 374px;
      padding: 24px 0 10px 6px;
      border-top: none;
      background-color: rgba(255, 255, 255, 0.6);
      border-radius: 0 0 10px 10px;

      ul {
        li {
          position: relative;
          list-style: none;
          line-height: 200%;
          width: 365px;
          margin: 0;
          padding: 0 8px;
          box-sizing: border-box;

          span {
            display: block;
            position: absolute;
            right: 8px;
            top: 1px;
          }

          font: normal 15px / 30px "SimSun",
          sans-serif;
          font-weight: 500;

          .title-text {
            white-space: nowrap;
            /* 禁止换行 */
            overflow: hidden;
            /* 超出内容隐藏 */
            text-overflow: ellipsis;
            /* 超出部分显示省略号 */
            max-width: 17em;
            display: inline-block;
            text-decoration: none;
            color: #333;

            &:hover {
              color: #1e63b0;
              text-decoration: underline;
            }
          }
        }
      }

      .view-more {
        font-weight: bold;
        text-align: right;
        padding: 0 16px 19px 0;
        box-sizing: border-box;
        width: 374px;
        border-radius: 0 0 12px 12px;
      }
    }
  }

  .member-intro {
    padding-left: 30px;
    width: 1200px;
    margin: 0 auto;
    padding-top: 20px;

    h1 {
      float: left;
      width: 55px;
      height: 197px;
    }

    .news {
      float: left;
      width: 1000px;
      background-color: #e6e6e6;
      border-radius: 8px;
      margin-left: 40px;
      height: 197px;
      padding: 14px 40px 0 40px;
      display: flex;
      justify-content: space-between;

      ul {
        width: 400px;

        li {
          list-style: square;

          a {
            color: #434343;

            font-size: 15px;
            font-weight: 500;
          }

          background-color: #fff;
          border-radius: 8px;
          padding: 6px 10px;
          margin-bottom: 10px;

        }
      }
    }
  }
}

.quick-link {
  border: 1px solid #ddd;
  border-top: none;
  overflow: hidden;
  height: 100%;
  padding: 8px 0;
  margin-bottom: 10px;

  li {
    float: left;
    width: 285px;
    height: 147px;
    background: url("~@/assets/images/bg01.png");
    margin-left: 6px;
    box-sizing: border-box;
    padding: 40px 0 0 28px;

    &.bg2 {
      background: url("~@/assets/images/bg02.png");
    }

    &.bg3 {
      background: url("~@/assets/images/bg03.png");
    }

    &.bg4 {
      background: url("~@/assets/images/bg04.png");
    }

    a {
      display: inline-block;
      text-align: center;
      background-color: #fff;
      padding: 4px 20px;
      border-radius: 2px;
      letter-spacing: 2px;
      font-size: 14px;
      font-weight: bold;
    }
  }
}

#list28 {
  li {
    display: flex;
    justify-content: space-around;
    width: 520px;

    .la {
      width: 450px;
      white-space: nowrap;
      /* 禁止文本换行 */
      overflow: hidden;
      /* 隐藏超出容器的内容 */
      text-overflow: ellipsis;
      /* 超出部分显示省略号 */
    }
  }
}

#list27 {
  li {
    display: flex;
  }
}
</style>
